import { gql } from '@apollo/client';
// Fragments
import { PaymentFields } from './fragments';

export const MY_PAYMENT_METHODS = gql`
  query MyPaymentMethods {
    myPaymentMethods {
      ...PaymentFields
    }
  }
  ${PaymentFields}
`;

export const GET_MY_PAYMENT_BY_EXTERNAL_ID = gql`
  query GetMyPaymentByExternalId($input: GetPaymentByExternalIdInput!) {
    getMyPaymentByExternalId(input: $input) {
      id
      status
      amount
      paidAt
      createdAt
      updatedAt
      ... on CryptoPayment {
        transactionId
      }
      orderSummary {
        id
        externalId
        type
        total
        subtotal
        tax
      }
    }
  }
`;
